<div class="version-container">{{ versionString }}</div>